import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';


import { DomSanitizer } from '@angular/platform-browser';

/**
 * Generated class for the ConfigurationCloseCashViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-analytics-sales-sales-view',
  templateUrl: 'analytics-sales-sales-view.html',
})
export class AnalyticsSalesSalesViewPage {

  show_dashboard: boolean;
  url_dashboard: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public sanitizer: DomSanitizer,
    public http: HttpClient,
    public toastCtrl: ToastController,
    public translate: TranslateService,
  ) {

    //Comprobamos que tenga el dasboard de analytics
    if (this.globals.restaurant.analytics_dashboard != undefined) {
      if (this.globals.restaurant.analytics_dashboard) {
        //Si lo tiene lo mostramos.
        this.show_dashboard = true;
        this.url_dashboard = this.sanitizer.bypassSecurityTrustResourceUrl(this.globals.restaurant.analytics_dashboard);
      } else {
        this.show_dashboard = false;
      }
    } else {
      //Si no lo tiene mostramos un texto para que lo pida
      this.show_dashboard = false;
    }
  }

  /**********************************************************/
  /*                          INIT                          */
  /**********************************************************/

  ionViewWillEnter() {

  }


  /**********************************************************/
  /*                    FUNCIONES DE NODE                   */
  /**********************************************************/



  /**********************************************************/
  /*                         CHARTS                         */
  /**********************************************************/




  /**********************************************************/
  /*                        FUNCIONES                       */
  /**********************************************************/



  async sendAddonAnalytics() {

    var msg = 'Activar integración Dashboard Analytics de ' + this.globals.restaurant.email + ' versión pro ' + this.globals.restaurant.license + ' telf. ' + this.globals.restaurant.phone + ' dirección ' + this.globals.restaurant.address + ' nombre restaurante ' + this.globals.restaurant.company + '.';
    //send
    await this.http.post(this.globals.api_path + 'slack/integrations', {
      msg: msg,
    }, {}).subscribe(async data => {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('toast-activar-dasboard-analytics'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();

    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/analytics/analytics-sales-sales-view/analytics-sales-sales-view.ts